import React, { useMemo, useState } from 'react';

import CKEditor from 'core/ui/CKEditor';
import { ContentState, convertFromHTML, convertToRaw } from 'draft-js';
import useActions from 'modules/map/useActions';
import Modules from 'modules';
import { showAPIError } from 'core/utils/showAPIError';
import { Dialog, DialogContent } from '@material-ui/core';
import DialogTitle from 'core/ui/Dialog/DialogTitle';
import Typography from 'core/ui/Typography';
import { useTranslation } from 'react-i18next';
import useSelectors from 'modules/map/useSelectors';
import { ownerableMessagesModule } from 'modules/ownerableMessages';

export const RichEditor = ({ form, ownerableType, ownerableId, isChannel }) => {
  const [preview, setPreview] = useState({ open: false });
  const { request } = useActions();
  const { t } = useTranslation();
  const text = form.watch('text');

  const loadingTestForm = useSelectors(ownerableMessagesModule, 'loadingTestForm');
  const textRaw = form.watch('textRaw');

  const previewClick = (data) => {
    request({
      action: Modules.ownerableMessages.actions.testFormContacts,
      data: {
        ...data,
        ownerableId,
        ownerableType,

        previewOnly: true,
        method: 'email',
        subject: form.watch('subject'),
        text,
      },
      options: {
        onSuccess: (resp) => {
          if (resp?.previewUrl) {
            setPreview({ open: true, url: resp?.previewUrl });
          }
        },
        onError: showAPIError,
      },
    });
  };

  let keys = ['{first_name}'];

  if (isChannel) {
    keys = [
      ...keys,
      '{channel_name}',
      '{channel_view_link}',
      '{channel_schedule_link}',
      '{channel_plans_link}',
    ];
  }

  const defaultValue = useMemo(
    () => {
      if (textRaw) {
        if (typeof textRaw === 'string') return JSON.parse(textRaw);

        return textRaw;
      }

      const blocksFromHTML = convertFromHTML(text || '');

      return convertToRaw(
        ContentState.createFromBlockArray(blocksFromHTML.contentBlocks, blocksFromHTML.entityMap),
      );
    },
    // We only need this to run one time. With this in mind, the unique manner to change this is unmounting and mounting again.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  return (
    <div>
      <CKEditor
        error={form.errors && form.errors.text}
        onChange={(v) => {
          form.setValue('text', v?.html);
          form.setValue('textRaw', v?.raw);
        }}
        defaultValue={defaultValue}
        bordered
        keywordOptions={keys}
        allowUploads
        pathUpload={`${ownerableType}/${ownerableId}/Messages`}
        previewEmailOptions={{ onClick: previewClick, loadingPreview: loadingTestForm }}
      />
      {preview?.open && (
        <Dialog
          open={preview?.open}
          scroll="body"
          maxWidth="sm"
          fullWidth
          onClose={() => setPreview({})}
        >
          <DialogTitle onClose={() => setPreview({})}>
            <Typography align="center" color="secondary" variant="h6">
              {t('workflow.testAction')}
            </Typography>
          </DialogTitle>

          <DialogContent>
            <div>
              <img src={preview?.url} alt="Preview Test" className="tw-w-full tw-object-contain" />
            </div>
          </DialogContent>
        </Dialog>
      )}
    </div>
  );
};
